<script lang="ts" setup>
// public/ 配下の画像参照は :src バインディング経由で行う（コンパイル時 import 化を回避、JCAT-4981）
const microsoftIconUrl = '/img/parts/microsoft.svg';
const chromeIconUrl = '/img/parts/chrome.svg';
</script>

<template>
  <main class="main">
    <div class="container">
      <div class="container-inner">
        <section class="error-area">
          <p class="sub_title">ご利用中のブラウザInternet Explorerは<br />このサービスではサポートされていません</p>
          <hr />
          <div class="desc">
            <p>
              お手数ですがMicrosoft Edge、Google Chromeなど<br />
              他のウェブブラウザでアクセスしてください。
            </p>
          </div>
          <div class="download">
            <a href="https://www.microsoft.com/ja-jp/edge"><img alt="Microsoft Edge ダウンロード" :src="microsoftIconUrl" /></a>
            <a href="https://www.google.co.jp/chrome/?brand=AGAK&gclid=CjwKCAjwqcKFBhAhEiwAfEr7zfBVbt7yZNI5G0H5stJZuw5_O5f5rvqYBOQuQAI5yixm_Vm6FMhEGBoCvJkQAvD_BwE&gclsrc=aw.ds">
              <img alt="google chrome ダウンロード" :src="chromeIconUrl" />
            </a>
          </div>
        </section>
      </div>
    </div>
  </main>
</template>

<style lang="scss" scoped>
$breakpoint: 780px;

.container {
  margin-top: 96px;
  min-height: 94vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
}

.container-inner {
  width: 660px;
  align-self: center;

  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.main {
  display: flex;
  flex-direction: column;
}

.main-inner {
  display: flex;
  flex-direction: column;
}

.error-area {
  padding: 56px 0 120px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}

.error-title {
  text-align: center;
  display: flex;
  flex-direction: column;

  &__ {
    &ja {
      color: #333;
      font-family: Playfair Display;
      font-size: 124px;
      line-height: 165px;
      letter-spacing: 6px;
      text-align: center;
      margin-bottom: 24px;
      @media screen and (min-width: $breakpoint) {
        font-size: 170px;
        margin-top: 66px;
        margin-bottom: 38px;
      }
    }

    &en {
      color: #333;
      font-family: Playfair Display;
      font-size: 28px;
      line-height: 18px;
      letter-spacing: 2px;
      text-align: center;
      margin-bottom: 24px;
    }
  }
}

.breadcrumbs {
  margin-left: 16px;
  margin-bottom: 24px;

  @media screen and (min-width: $breakpoint) {
    margin-left: 0;
  }
}

.sub_title {
  color: #333;
  font-size: 14px;
  line-height: 28px;
  letter-spacing: 0.5px;
  text-align: center;
  font-weight: bold;
  @media screen and (min-width: $breakpoint) {
    font-size: 16px;
    line-height: 28px;
    letter-spacing: 1.4px;
  }
}
hr {
  border: none;
  border-top: 1px solid #333;
  width: 120px;
  margin: 36px auto;
  @media screen and (min-width: $breakpoint) {
    width: 325px;
    margin: 40px auto;
  }
}
.desc {
  margin: 0 24px 48px;
  max-width: 640px;
  @media screen and (min-width: $breakpoint) {
    margin: 0 auto 56px;
  }
  p {
    color: #333;
    font-size: 12px;
    line-height: 22px;
    letter-spacing: 0.5px;
    text-align: justify;
    @media screen and (min-width: $breakpoint) {
      font-size: 14px;
      line-height: 32px;
      letter-spacing: 1px;
      text-align: center;
    }
  }
}
.download {
  display: flex;
  width: 280px;
  justify-content: space-between;
}
</style>
